
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import CrudLayout from "@/layouts/CrudLayout.vue";
import Validation from "@/components/Validation.vue";
import AdminForm from "./AdminForm.vue";
import FormCreate from "@/views/form/create/FormCreate.vue";

const namespace: string = "admin";

@Component({
  components: {
    CrudLayout,
    Validation,
    AdminForm
  },
  extends: FormCreate
})
export default class AdminCreate extends Vue {
  public name: string = "AdminCreate";
  private resourceName = "admin";

  @Getter("getError", { namespace }) error: any;
  @Getter("isLoading", { namespace }) loading: any;
  @Getter("isCreated", { namespace }) created: any;
  @Getter("getItem", { namespace }) createdItem: any;

  @Action("create", { namespace }) createItemAction: any;
  @Action("resetCreate", { namespace }) resetAction: any;

  beforeDestroy() {
    this.resetAction();
  }
}
